import { FieldProps } from 'components/Wizards/Wizard/Form/Types'
import { SelectInput } from 'components/Wizards/Wizard/Form/SelectInput'
import { Item } from '@react-stately/collections'
import { capitalize } from 'lodash'
import { TextInput } from 'components/Wizards/Wizard/Form/TextInput'
import { SelectPillsInput } from 'components/Wizards/Wizard/Form/SelectPillsInput'

export const StringInput = ({ name, schema, autoFocus }: FieldProps) => {
  const {
    meta: { placeholder, rows, label, oneOfPills, pillsCarousel, size },
    oneOf,
  } = schema.describe()
  const isSelect = oneOf.length > 0

  if (isSelect) {
    if (oneOfPills) {
      return (
        <SelectPillsInput name={name} aria-label={label} isCarousel={pillsCarousel} size={size} chipVariant="flat">
          {oneOf.map((option: string) => (
            <Item key={option}>{option}</Item>
          ))}
        </SelectPillsInput>
      )
    }

    return (
      <SelectInput name={name} aria-label={label}>
        {oneOf.map((option: string) => (
          <Item key={option}>{capitalize(option.toLowerCase())}</Item>
        ))}
      </SelectInput>
    )
  }

  return <TextInput name={name} placeholder={placeholder} rows={rows} autoFocus={autoFocus} variant="grey" />
}
